const styles = theme => ({
	root: {
		paddingLeft: 0,
		paddingRight: 0,
	},

	editIcon: {
		color: '#009AC9',
	},

	editZonesIcon: {
		fill: '#009AC9',
	},

	icon: {
		fill: '#009AC9',
		width: 14,
		height: 14,
	},

	icons: {
		display: 'flex',
		alignItems: 'center',
	},

	checkIcon: {
		color: '#51B383',
	},
});

export default styles;